import React, { useState } from 'react';
import StartScreen from './components/StartScreen';
import QuestionScreen from './components/QuestionScreen';
import ResultScreen from './components/ResultScreen';
import { questions } from './data/questions';
import { getResultType } from './utils/calculateResult';
import './App.css';

function App() {
  // 앱의 현재 상태를 관리하는 State들입니다.
  const [step, setStep] = useState('start'); // 화면 단계 제어: 'start'(시작), 'test'(질문), 'result'(결과)
  const [currentIdx, setCurrentIdx] = useState(0); // 현재 풀고 있는 질문의 번호 (인덱스)
  const [scoreA, setScoreA] = useState(0); // A 성향(도파민/액티브)을 선택한 개수 누적
  const [resultData, setResultData] = useState(null); // 최종 계산된 결과 데이터 객체

  // 시작 버튼을 눌렀을 때 실행되는 함수
  const handleStart = () => {
    setStep('test'); // 질문 화면으로 전환
    setCurrentIdx(0); // 인덱스 초기화
    setScoreA(0); // 점수 초기화
  };

  // 결과 화면에서 '다시하기'를 눌렀을 때 실행되는 함수
  const handleRestart = () => {
    setStep('start'); // 질문이 아닌 첫 '시작 화면'으로 이동
    setCurrentIdx(0);
    setScoreA(0);
    setResultData(null); // 저장된 결과값도 비움
  };

  // 사용자가 답변(A 또는 B)을 클릭할 때마다 실행되는 함수
  const handleAnswer = (type) => {
    // A 타입을 선택했다면 점수를 1 올립니다.
    if (type === 'A') {
      setScoreA((prev) => prev + 1);
    }

    // 아직 풀 질문이 남았다면 다음 질문으로 넘깁니다.
    if (currentIdx < questions.length - 1) {
      setCurrentIdx((prev) => prev + 1);
    } else {
      // 마지막 질문까지 다 풀었다면 결과 도출 로직을 실행합니다.
      // 현재 누적된 scoreA에 방금 선택한 타입이 A라면 +1을 더해 최종 점수를 넘깁니다.
      const finalResult = getResultType(scoreA + (type === 'A' ? 1 : 0));
      setResultData(finalResult); // 계산된 결과를 저장
      setStep('result'); // 결과 화면으로 전환
    }
  };

  return (
    <div className="app-wrapper">
      <div className="app-container">
        {/* step 상태에 따라 조건부 렌더링을 통해 화면을 교체합니다. */}
        {step === 'start' && <StartScreen onStart={handleStart} />}
        
        {step === 'test' && (
          <QuestionScreen currentIdx={currentIdx} onAnswer={handleAnswer} />
        )}
        
        {step === 'result' && (
          <ResultScreen resultData={resultData} onRestart={handleRestart} />
        )}
      </div>
    </div>
  );
}

export default App;